<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>Loading...</strong>
            <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
        </div>

        <div v-else class="enqContent"><i v-if="disabled || po.cancelled" class="fragment-disabled"></i>
            <h4 v-if="po.cancelled" class="text-danger ml-2">CANCELLED</h4>
            <hr v-if="po.cancelled" class="mb-3 w-100">

            <form autocomplete="off" role="form" class="form form-inline">
                <div v-if="po.POID" class="form-group align-items-center mb-3 w-100">
                    <label
                        for="POID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>PO ID</strong>
                    </label>
                    <label
                        for="POID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>PO ID</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <span>{{ po.POID }}</span>
                    </div>
                </div>

                <hr v-if="po.POID" class="mt-1 mb-3 w-100">

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="supplier"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Supplier</strong>
                    </label>
                    <label
                        for="supplier"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Supplier</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="text"
                            autocomplete="off"
                            class="form-control w-100"
                            v-model="supplierName"
                            readonly
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="notes"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Notes</strong>
                    </label>
                    <label
                        for="notes"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Notes</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <textarea
                            v-model="notes"
                            class="form-control w-100"
                            id="notes"
                            rows="8"
                            :disabled="disabled || po.cancelled"
                        ></textarea>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="supplierContactID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Supplier Contact</strong>
                    </label>
                    <label
                        for="supplierContactID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Supplier Contact</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="supplierContactID"
                            id="supplierContactID"
                            class="form-control w-100 custom-select"
                            :disabled="disabled || po.cancelled"
                            required
                        >
                            <option
                                value=""
                                disabled
                            >{{ __('Please select.') }}</option>
                            <option
                                v-for="contact in supplierContacts"
                                :key="contact.ID"
                                :value="contact.ID"
                            >{{ __(contact.contactName) }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="userID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>DAX Contact</strong>
                    </label>
                    <label
                        for="userID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>DAX Contact</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="userID"
                            id="userID"
                            class="form-control w-100 custom-select"
                            :disabled="disabled || po.cancelled"
                            required
                        >
                            <option
                                value=""
                                disabled
                            >{{ __('Please select.') }}</option>
                            <option
                                v-for="(user, id) in daxisContactsFiltered"
                                :key="id"
                                :value="id"
                            >{{ __(user.full_name) }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="bankCharges"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Bank Charges ({{ po.supplier.currency.symbol }})</strong>
                    </label>
                    <label
                        for="bankCharges"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Bank Charges ({{ po.supplier.currency.symbol }})</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="number"
                            autocomplete="off"
                            step="0.01"
                            min="0"
                            maxlength="20"
                            v-model.number="bankCharges"
                            class="form-control w-100"
                            id="bankCharges"
                            :disabled="disabled || po.cancelled"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="packagingHandling"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Packaging and Handling ({{ po.supplier.currency.symbol }})</strong>
                    </label>
                    <label
                        for="packagingHandling"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Packaging and Handling ({{ po.supplier.currency.symbol }})</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="number"
                            autocomplete="off"
                            step="0.01"
                            min="0"
                            maxlength="20"
                            v-model.number="packagingHandling"
                            class="form-control w-100"
                            id="packagingHandling"
                            :disabled="disabled || po.cancelled"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="discount"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Discount ({{ po.supplier.currency.symbol }})</strong>
                    </label>
                    <label
                        for="discount"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Discount ({{ po.supplier.currency.symbol }})</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="number"
                            autocomplete="off"
                            step="0.01"
                            min="0"
                            maxlength="20"
                            v-model.number="discount"
                            class="form-control w-100"
                            id="discount"
                            :disabled="disabled || po.cancelled"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="voucher"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Voucher ({{ po.supplier.currency.symbol }})</strong>
                    </label>
                    <label
                        for="voucher"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Voucher ({{ po.supplier.currency.symbol }})</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="number"
                            autocomplete="off"
                            step="0.01"
                            min="0"
                            maxlength="20"
                            v-model.number="voucher"
                            class="form-control w-100"
                            id="voucher"
                            :disabled="disabled || po.cancelled"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="credit"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Credit ({{ po.supplier.currency.symbol }})</strong>
                    </label>
                    <label
                        for="credit"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Credit ({{ po.supplier.currency.symbol }})</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="number"
                            autocomplete="off"
                            step="0.01"
                            min="0"
                            maxlength="20"
                            v-model.number="credit"
                            class="form-control w-100"
                            id="credit"
                            :disabled="disabled || po.cancelled"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-3 w-100">
                    <label
                        for="paymentMethodID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Payment Method</strong>
                    </label>
                    <label
                        for="paymentMethodID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Payment Method</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="paymentMethodID"
                            id="paymentMethodID"
                            class="form-control w-100 custom-select"
                            :disabled="disabled || po.cancelled"
                            required
                        >
                            <option
                                value=""
                                disabled
                            >{{ __('Please select.') }}</option>
                            <option
                                v-for="method in paymentMethods"
                                :key="method.ID"
                                :value="method.ID"
                            >{{ __(method.paymentMethod) }}</option>
                        </select>
                    </div>
                </div>

                <div
                    class="offset-xs-0 offset-xl-3 col-xs-12 col-xl-9 d-flex align-items-center w-100"
                >
                    <div class="d-inline-block px-0">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            :disabled="notReady || po.cancelled"
                            @click.prevent="onUpdate"
                        >Update</button>

                        <button
                            type="submit"
                            class="btn btn-primary"
                            :disabled="notReady || 0 !== po.POID"
                            @click.prevent="onGenerate"
                        >Generate POID</button>

                        <button
                            type="submit"
                            class="btn btn-secondary"
                            :disabled="notReady || !po.POID"
                            @click.prevent="onDownload"
                        >Download</button>

                        <button
                            type="submit"
                            class="btn btn-danger"
                            :disabled="notReady || !po.POID || po.cancelled"
                            @click.prevent="onCancel"
                        >Cancel</button>
                    </div>

                    <div class="d-flex align-items-center w-100" v-if="updating">
                        <strong class="ml-4">Updating...</strong>
                        <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqFragmentPurchaseOrder",

    props: {
        enquiry: {
            required: true,
            type: Object,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        updateEnquiry: {
            required: true,
            type: Function,
        },

        po: {
            required: true,
            type: Object,
        },

        updateStats: {
            required: true,
            type: Function,
        },
    },

    data() {
        return {
            loaded: false,
            updating: false,

            supplierName: this.po.supplier.supplierName,
            supplierContacts: [],
            daxisContacts: [],
            paymentMethods: [],

            notes: this.po.notes,
            supplierContactID:
                this.po.supplierContactID > 0 ? this.po.supplierContactID : "",
            userID: this.po.userID > 0 ? this.po.userID : "",

            bankCharges: this.po.bankCharges,
            packagingHandling: this.po.packagingHandling,
            discount: this.po.discount,
            voucher: this.po.voucher,
            credit: this.po.credit,

            paymentMethodID:
                this.po.paymentMethodID > 0 ? this.po.paymentMethodID : "",
        };
    },

    computed: {
        daxisContactsFiltered() {
            let output = {};
            var current_user = this.po.userID;

            this.daxisContacts.forEach((user) => {
                if (
                    [2, 3, 4].indexOf(user.departmentID) > -1 ||
                    current_user === user.id
                ) {
                    output[user.id] = user;
                }
            });

            return output;
        },

        notReady() {
            return (
                this.updating ||
                this.disabled ||
                !this.supplierContactID ||
                !this.userID ||
                !this.paymentMethodID
            );
        },
    },

    methods: {
        onGenerate() {
            this._onUpdate("generate");
        },

        onDownload() {
            this._onUpdate("download", (data) => {
                window.open(data.url);
            });
        },

        onCancel() {
            this._onUpdate("cancel");
        },

        onUpdate() {
            this._onUpdate();
        },

        _onUpdate(method = "update", callback) {
            this.updating = true;

            axios
                .post("/api/enquiries/fragment/purchase-order/" + method, {
                    poID: this.po.ID,

                    notes: this.notes,
                    supplierContactID: this.supplierContactID,
                    userID: this.userID,

                    bankCharges: this.bankCharges,
                    packagingHandling: this.packagingHandling,
                    discount: this.discount,
                    voucher: this.voucher,
                    credit: this.credit,

                    paymentMethodID: this.paymentMethodID,
                })
                .then((response) => {
                    // console.log(response);
                    this.updating = false;

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.updateEnquiry(data.enquiry);

                        if (data.calculated_stats) {
                            this.updateStats(data.calculated_stats);
                        }

                        if (callback) {
                            callback(data);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },
    },

    watch: {},

    mounted() {
        axios
            .post("/api/enquiries/fragment/purchase-order/get", {
                poID: this.po.ID,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;

                    this.supplierContacts = data.supplierContacts;
                    this.daxisContacts = data.daxisContacts;
                    this.paymentMethods = data.paymentMethods;
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    },
};
</script>
